import styled from 'styled-components';
import { Link } from 'gatsby';

import Container from '../Container';

export const FooterSection = styled.section`
  background-color: #D0F5F5;
  padding: 48px 32px;
  text-align: center;
`;

export const FooterContainer = styled(Container)`
  max-width: 800px;
  margin: 0 auto;
`;

export const FooterButtons = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;
`;

export const FooterButton = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 16px 32px;
  background: rgba(27, 24, 87, 0.1);
  border: 2px solid rgba(27, 24, 87, 0.2);
  border-radius: 12px;
  color: #1B1857;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(27, 24, 87, 0.15);
    border-color: rgba(27, 24, 87, 0.3);
    color: #1B1857;
    transform: translateY(-2px);
  }
  
  @media (min-width: 768px) {
    padding: 18px 36px;
    font-size: 18px;
  }
`;

export const FooterLinkButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 16px 32px;
  background: rgba(27, 24, 87, 0.1);
  border: 2px solid rgba(27, 24, 87, 0.2);
  border-radius: 12px;
  color: #1B1857;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(27, 24, 87, 0.15);
    border-color: rgba(27, 24, 87, 0.3);
    color: #1B1857;
    transform: translateY(-2px);
  }
  
  @media (min-width: 768px) {
    padding: 18px 36px;
    font-size: 18px;
  }
`;